import { Box } from '@mui/material';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as BinocularsIcon } from 'assets/icons/binocular.svg';
import { Spinner } from 'components';
import { Links } from 'settings';
import { cropText } from 'utils';

import { EmptyStateKpi } from '../../components';
import { useGetKpiDetailsQuery } from '../../hooks';
import { TARGETS_LIMIT, VISION_LENGTH } from './constants';
import {
  InnerContainer,
  PreviewSection,
  SectionTitle,
  VisionCardHeader,
  VisionContent,
  VisionIconBg,
  VisionW,
} from './styled';

export function VisionPreview(): ReactElement {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { isLoading, vision } = useGetKpiDetailsQuery({
    limit: TARGETS_LIMIT,
    kpi_status: 'active',
  });

  const handleVisionClick = () => {
    navigate(Links.we.kpi.index);
  };

  return (
    <PreviewSection>
      {isLoading && <Spinner size={24} />}

      {!isLoading && (
        <>
          <SectionTitle>{t('kpi.preview.vision')}</SectionTitle>
          <InnerContainer>
            {vision ? (
              <VisionW>
                <VisionCardHeader>
                  <VisionIconBg>
                    <BinocularsIcon />
                  </VisionIconBg>
                </VisionCardHeader>
                <VisionContent
                  onClick={handleVisionClick}
                  dangerouslySetInnerHTML={{ __html: cropText(vision, VISION_LENGTH) }}
                />
              </VisionW>
            ) : (
              <Box sx={{ padding: '8px', height: '100%' }}>
                <EmptyStateKpi type="vision" />
              </Box>
            )}
          </InnerContainer>
        </>
      )}
    </PreviewSection>
  );
}
